// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDHnu28T-BWBxf3_Kjb4t4_2SF9NXs33vI",
  authDomain: "kubotaptap.firebaseapp.com",
  databaseURL: "https://kubotaptap-default-rtdb.asia-southeast1.firebasedatabase.app/",
  projectId: "kubotaptap",
  storageBucket: "kubotaptap.firebasestorage.app",
  messagingSenderId: "644281044307",
  appId: "1:644281044307:web:6cc1e0cdd445724f8365a6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const database = getDatabase(app);

export {
  app,
  analytics,
  database
};
